import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "x-t-cell-select-editor x-cell-editor"
};
const _hoisted_2 = {
  key: 1,
  class: "x-cell-editor"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_select = _resolveComponent("a-select");
  return $props.editMode ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("span", {
    class: _normalizeClass({
      'inner-border': true,
      'input-error': $props.error
    })
  }, [_createVNode(_component_a_select, {
    style: {
      width: '100%',
      height: '100%',
      borderRadius: 0,
      padding: '1px 5px'
    },
    bordered: $setup.isFocused,
    options: $props.options,
    value: $setup.selectValue,
    "onUpdate:value": $setup.handleUpdateValue,
    onFocus: $setup.handleFocus,
    onBlur: $setup.handleBLur
  }, null, 8, ["bordered", "options", "value", "onUpdate:value", "onFocus", "onBlur"])], 2)])) : (_openBlock(), _createElementBlock("span", _hoisted_2, [_createElementVNode("span", {
    class: _normalizeClass({
      'input-error': !!$props.error
    })
  }, _toDisplayString($setup.displayText), 3)]));
}